module.exports = __webpack_public_path__ + "img/xuqiuguangchang1.36d6c014.png";